import { Navigate, useSearchParams } from "react-router";

import { useAuthCallbackQuery } from "@/data/queries";

export const AuthCallback = () => {
  const { isLoading, isError, error } = useAuthCallbackQuery();
  const [searchParams] = useSearchParams();

  const state = searchParams.get("state");

  if (isLoading) {
    return <div className="h-screen" />;
  }

  if (isError) {
    return <div className="h-screen">Error: {error.message}</div>;
  }

  return <Navigate to={state ?? "/skus"} />;
};
